import { render, staticRenderFns } from "./ReviewMediaSectionPc.vue?vue&type=template&id=adede032&scoped=true"
import script from "./ReviewMediaSectionPc.vue?vue&type=script&lang=js"
export * from "./ReviewMediaSectionPc.vue?vue&type=script&lang=js"
import style0 from "./ReviewMediaSectionPc.vue?vue&type=style&index=0&id=adede032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adede032",
  null
  
)

export default component.exports